<template>
    <div class="instagram-interface" ref="instagramInterface">
        <div class="page-name">
            <p>{{ page ? page.name : 'Instagram' }}</p>
        </div>
        <div class="user-info">
            <div class="picture">
                <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'">
            </div>
            <div class="stats">
                <div class="stat">
                    <p>{{ statsProfile.media_count }}</p>
                    <label>Publications</label>
                </div>
                <div class="stat">
                    <p>{{ statsProfile.followers_count }}</p>
                    <label>Followers</label>
                </div>
                <div class="stat">
                    <p>{{ statsProfile.follows_count }}</p>
                    <label>Suivi(e)s</label>
                </div>
            </div>
        </div>
        <div class="nav">
            <div class="item" :class="{ active: activeTab === 'feed' }" :title="$t('dash.post.feed')" @click="activeTab = 'feed'">
                <svg fill="currentColor" height="100%" width="100%" viewBox="0 0 24 24" ><rect fill="none" height="18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" width="18" x="3" y="3"></rect><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="9.015" x2="9.015" y1="3" y2="21"></line><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="14.985" x2="14.985" y1="3" y2="21"></line><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="21" x2="3" y1="9.015" y2="9.015"></line><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="21" x2="3" y1="14.985" y2="14.985"></line></svg>
            </div>
            <div class="item" :class="{ active: activeTab === 'reels' }" :title="$t('dash.post.reels')" @click="activeTab = 'reels'">
                <svg fill="none" height="100%" width="100%" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" stroke-width="2"/><path d="M9,8 L9,16 L16,12 Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/></svg>
            </div>
        </div>
        <div class="container-grid hide-scrollbar" @scroll="handleScroll" ref="scrollContainer">
            <draggable 
                class="list-photo hide-scrollbar" 
                ref="listMedia" 
                v-model="list" 
                v-bind="dragOptions" 
                :move="checkMove"
                :filter="'.posted'"
                @start="drag=true" 
                @end="drag=false"   
                @update="updateList"
                >
                <transition-group type="transition" :name="'flip-list'">
          
                    <div 
                      
                        class="photo" 
                        :class="[post.status, post.type]"
                        v-for="post in list" :key="post.id"
                        :style="{ backgroundImage: `url(${post.url})` }"
                        :id="post.id"
                    >

                        <div class="circle-status card-status-background-primary-color" :class=[post.status]></div>
                    </div>

                    <div 
                        v-if="loadingCard"
                        class="photo loading" 
                        v-for="(test, index) in Array.from({length: this.list.length % 3 + 6})"
                        :key="`loading-${index}`"
                        :style="`animation-delay: ${index * 0.2}s`"
                        >
                    </div>
  
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
    export default {
        components: {
            draggable
        },
        props: {
            plannedItems: Array,
            postedItems: Array,
            pinnedItems: Array,
            page: Object,
            statsProfile:Object,
            loadingCard:Boolean
        },
        
        data() {
            return {
                list: [],
                activeTab: 'feed',
                _scrollTimer: null,
            };
        },

        mounted () {

        },

        methods: {
            updateList(e) {
                console.log("updateList",e)
                this.$nextTick(()=>{
                    const postId =  e.item.id
                    const msInterval = 5 * 60 * 1000 //5minutes

                    let itemIndex = -1 
                    let newDate

                    const posts = this.list.filter(item => !['posted'].includes(item.status))

                    itemIndex = posts.findIndex(post => post.id == postId)
                
                    if (itemIndex >= 0) {
                        console.log('find',itemIndex)
                        
                        if (itemIndex == 0 && posts[1]) {
                            //retire 5minutes par rapport a l'avant derniere date
                            console.log("first", posts[1].date)
                            newDate = new Date(new Date(posts[1].date).getTime() + msInterval).toISOString()
                            posts[itemIndex].date = newDate
                        }

                        else if (itemIndex == posts.length - 1 && posts[itemIndex-1]) {
                            console.log("last", posts[itemIndex-1].date)
                            //ajouter 5minutes par rapport a la derniere date
                            newDate = new Date((new Date(posts[itemIndex-1].date)).getTime() - msInterval).toISOString()
                            posts[itemIndex].date = newDate
    
                        }else {
                            const datePostBefore = new Date(posts[itemIndex+1].date).getTime() 
                            const datePostAfter = new Date(posts[itemIndex-1].date).getTime()
                            if (e.newIndex > e.oldIndex) {
                                //ajoute 5minutes par rapport a la date d'avant
                                console.log("ajoute 5minutes par rapport a la date plus future")
                                newDate = datePostAfter - msInterval
                                
                                if (newDate <= datePostBefore) {
                                    newDate = (datePostAfter - datePostBefore) / 2 + datePostBefore
                                }

                                newDate = new Date(newDate).toISOString()
                                posts[itemIndex].date = newDate
                            }else{
                                //ajoute 5minutes par rapport a la date d'apres
                                console.log("ajoute 5minutes par rapport a la date plus proche",newDate,datePostAfter)
                                newDate = datePostBefore + msInterval
                            
                                if (newDate >= datePostAfter) {
                                    newDate = (datePostAfter - datePostBefore) / 2 + datePostBefore
                                }

                                newDate = new Date(newDate).toISOString()
                                posts[itemIndex].date = newDate
                            }
                        }
                    }
                  
                
     

                    if (itemIndex >= 0 && newDate) {
                        this.list = [...this.pinnedItems, ...posts, ...this.filteredPostedItems]
       
                        this.$emit('changeDate', {
                            postId,
                            newDate,
                            itemsSort: posts,
                            refreshGroupedItems: true
                        })
                
                    }
                })
            },
            isDisabled(item, index) {
                return index === 0 || index === this.items.length - 1; // Désactive le premier et dernier élément
            },
            checkMove(event) {
                // Empêche le déplacement du premier et dernier élément
                if (this.list[event.relatedContext.index].status == 'posted') {
                    return false;
                }
                return true;
            },

            handleScroll() {
                clearTimeout(this._scrollTimer)
                this._scrollTimer = setTimeout(() => {
                    const container = this.$refs.scrollContainer
                    if (!container) return
                    if (container.clientWidth * 0.41 >= container.scrollHeight - (container.clientHeight + container.scrollTop)) {
                        this.$emit('loadMorePostedItems')
                    }
                }, 150)
            },
        },

        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            filteredPlannedItems() {
                if (this.activeTab === 'reels')
                    return this.plannedItems.filter(p => p.type === 'reel')
                return this.plannedItems
            },
            filteredPostedItems() {
                if (this.activeTab === 'reels')
                    return this.postedItems.filter(p => p.type === 'reel')
                return this.postedItems.filter(p => p.type !== 'reel' || p.is_shared_to_feed !== false)
            },
        },
        watch: {
            plannedItems: {
                immediate: true,
                handler() {
                    this.list = [...this.pinnedItems, ...this.filteredPlannedItems, ...this.filteredPostedItems]
                }
            },
            postedItems: {
                immediate: true,
                handler() {
                    this.list = [...this.pinnedItems, ...this.filteredPlannedItems, ...this.filteredPostedItems]
                    this.$nextTick(() => this.handleScroll())
                }
            },
            activeTab() {
                this.list = [...this.pinnedItems, ...this.filteredPlannedItems, ...this.filteredPostedItems]
                this.$nextTick(() => this.handleScroll())
            },
        },

        beforeDestroy() {
            clearTimeout(this._scrollTimer)
        }
    }
</script>
